import React from "react";
import { FaLongArrowAltRight } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { Link } from "react-router-dom";

const Section6 = () => {
  return (
    <div>
      <section className="price bg-light">
        <div className="container flow-content">
          <h2 className="section-heading">Pricing</h2>

          <p className="price__para">
            We offer clear pricing suited to a variety of events. Each package
            covers essential decor and coordination to meet your requirements.
          </p>

          <div className="price__list split">
            <div className="price__listItem">
              <h4>Baby Shower</h4>

              <h3>₹35,000</h3>
              <p className="price__listItem-desc">
                Simple, elegant decor arranged for baby shower events.
              </p>
              <div className="price__listItem-pointers">
                <ul>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Color scheme selection</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Setup planning</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Personalized details</span>
                  </li>
                </ul>
              </div>
              <Link to="/contact" className="section-links">
                <span className="arrow__icon">
                  <FaLongArrowAltRight />
                </span>
                <span>Booking Now</span>
              </Link>
            </div>
            <div className="price__listItem">
              <h4>Birthday</h4>

              <h3>₹40,000</h3>
              <p className="price__listItem-desc">
                Basic decor and setup tailored for birthday celebrations.
              </p>
              <div className="price__listItem-pointers">
                <ul>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Theme customization</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Styling coordination</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Event assistance</span>
                  </li>
                </ul>
              </div>
              <Link to="/contact" className="section-links">
                <span className="arrow__icon">
                  <FaLongArrowAltRight />
                </span>
                <span>Booking Now</span>
              </Link>
            </div>
            <div className="price__listItem bg-accent">
              <h4>Bridal Shower</h4>

              <h3>₹45,000</h3>
              <p className="price__listItem-desc">
                Classic styling and coordination for bridal shower occasions.
              </p>
              <div className="price__listItem-pointers">
                <ul>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Theme development</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Detailed event support</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Coordination services</span>
                  </li>
                </ul>
              </div>
              <Link to="/contact" className="section-links">
                <span className="arrow__icon">
                  <FaLongArrowAltRight />
                </span>
                <span>Booking Now</span>
              </Link>
            </div>
            <div className="price__listItem">
              <h4>Adult Celebrations</h4>

              <h3>₹50,000</h3>
              <p className="price__listItem-desc">
                Decor and event management for adult gatherings and parties.
              </p>
              <div className="price__listItem-pointers">
                <ul>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Custom design options</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Coordination support</span>
                  </li>
                  <li>
                    <span>
                      <TiTick className="tick-icon" />
                    </span>
                    <span>Experience management</span>
                  </li>
                </ul>
              </div>
              <Link to="/contact" className="section-links">
                <span className="arrow__icon">
                  <FaLongArrowAltRight />
                </span>
                <span>Booking Now</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Section6;
